// extracted by mini-css-extract-plugin
module.exports = {"editor":"editorStyles_editor__3deMh","headlineButtonWrapper":"editorStyles_headlineButtonWrapper__2AyY9","headlineButton":"editorStyles_headlineButton__3r4R6"};